module.exports = __webpack_public_path__ + "img/84.7c6fdc75.png";